const journey = [
  {
    id: 1,
    type: "normal",
    title: "Bachelor's Degree in Accounting",
    desc: "Graduated with a Bachelor's in Accounting from Cairo University.",
    year: 2013,
    location: "Cairo University",
    tags: ["#Accounting", "#University"],
  },
  {
    id: 3,
    type: "odd",
    title: "Bachelor's Degree in Computer Science",
    desc: "Studied Computer Science at Cairo University from 2014 to 2018, building a strong foundation in programming, software development, and computer science fundamentals.",
    year: "2018",
    location: "Cairo University",
    tags: ["#ComputerScience", "#Programming", "#CairoUniversity"],
  },
  {
    id: 4,
    type: "normal",
    title: "Freelancer on Khamsat",
    desc: "Delivered tailored web solutions to clients, building user-friendly websites and maintaining high client satisfaction.",
    year: 2018,
    location: "Remote",
    tags: ["#HTML", "#CSS", "#React", "#Freelance"],
  },
  {
    id: 5,
    type: "odd",
    title: "Product-Focused UI/UX Designer at Hsoub",
    desc: "Worked remotely on Hsoub's main platform, designing and implementing user-focused interfaces with attention to performance, responsiveness, and seamless collaboration with backend teams.",
    year: 2019,
    location: "Remote - UK",
    tags: ["#HTML", "#CSS", "#JavaScript", "#Agile", "#UI/UX", "#FrontendDesign"],
  },
  {
    id: 6,
    type: "normal",
    title: "Educational Instructor at Hsoub Academy",
    desc: "Created and published high-quality video courses on Electron.js and Hugo, while supporting students.",
    year: 2020,
    location: "Hsoub Academy",
    tags: ["#ElectronJS", "#Hugo", "#Education"],
  },
  {
    id: 7,
    type: "odd",
    title: "Sndian Platform Development",
    desc: "Built 150+ user-focused UI sections and 80+ optimized templates on the Sndian platform, enabling seamless user customization and a polished product experience.",
    year: 2022,
    location: "Remote",
    tags: ["#UI/UX", "#Templates", "#Support"],
  },
  {
    id: 8,
    type: "normal",
    title: "Sndian Community Customization",
    desc: "Customized and translated the forum system for RTL Arabic support, improving accessibility for users.",
    year: 2023,
    location: "Remote",
    tags: ["#Flarum", "#RTL", "#Localization"],
  }
];

export default journey;
